import './scss/fonts.scss';

import PageViewer from './components/PageViewer.vue';
import availableWidgets from './components/widgets/available-widgets';
import getNaturalSize from './components/widgets/image/image-utils';
import * as SCALE_POSITIONS from './constants/positions';

export default {
  availableWidgets,
  PageViewer,
  imageUtils: {
    getNaturalSize,
  },
  consts: {
    SCALE_POSITIONS,
  },
};
